import { useSelector } from 'react-redux';
import { getLastWins } from '../selectors';

export const useUserLastWins = () => ({
  lastWins: useSelector(getLastWins),
});
